"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerMessageVariables = void 0;
var runtypes_1 = require("runtypes");
exports.ServerMessageVariables = (0, runtypes_1.Dictionary)(runtypes_1.Unknown, runtypes_1.String);
